import { useCallback, useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { Modal, MoneyInput, Notice, Pager, Stat, parseMoney } from "../../lib/ui";

/*
 * Customer advances / pre-payments – port of ext_fund.php (API: /api/advances)
 * Recording posts Dr Cash 1000, Cr 2100; refunding posts the reverse and marks the advance Paid.
 */

export default function Advances() {
  const api = useApi();
  const [clients, setClients] = useState([]);
  const [f, setF] = useState({ client_id: "", payment_amount: "", payment_method: "Cash", payment_details: "" });
  const [d, setD] = useState(null);
  const [page, setPage] = useState(1);
  const [notice, setNotice] = useState(null);
  const [refund, setRefund] = useState(null);
  const load = useCallback((p) => api.get("/api/advances", { page: p }).then(setD).catch((e) => setNotice({ tone: "err", text: e.message })), [api]);
  useEffect(() => { load(page); }, [load, page]);
  useEffect(() => { api.get("/api/clients").then(setClients).catch(() => {}); }, [api]);
  const save = async (e) => {
    e.preventDefault();
    try { const r = await api.post("/api/advances", { ...f, payment_amount: parseMoney(f.payment_amount) }); setNotice({ tone: "ok", text: r.message }); setF({ ...f, payment_amount: "", payment_details: "" }); load(page); }
    catch (err) { setNotice({ tone: "err", text: err.message }); }
  };
  const doRefund = async () => {
    const r0 = refund; setRefund(null);
    try { const r = await api.post(`/api/advances/${r0.payment_id}/refund`, {}); setNotice({ tone: "ok", text: r.message }); load(page); }
    catch (e) { setNotice({ tone: "err", text: e.message }); }
  };
  return (
    <main className="pg">
      <PageHeader slug="ext_fund" />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      {d && <div className="ui-stats"><Stat icon="fa-hand-holding-dollar" tone="warn" label="Open advances" value={d.total} /><Stat icon="fa-coins" label="Held for customers" value={n2(d.outstanding)} unit="TZS" /></div>}
      <section className="panel" style={{ marginBottom: "1.25rem" }}>
        <form className="form" onSubmit={save} style={{ maxWidth: "none" }}>
          <div className="field"><label htmlFor="ad-c">Client</label><select id="ad-c" required value={f.client_id} onChange={(e) => setF({ ...f, client_id: e.target.value })}>
            <option value="">Select client</option>{clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
          <div className="field"><label htmlFor="ad-a">Amount (TZS)</label><MoneyInput id="ad-a" required value={f.payment_amount} onChange={(v) => setF({ ...f, payment_amount: v })} /></div>
          <div className="field"><label htmlFor="ad-m">Method</label><select id="ad-m" value={f.payment_method} onChange={(e) => setF({ ...f, payment_method: e.target.value })}>
            {["Cash", "Bank Transfer", "Mobile Money"].map((m) => <option key={m}>{m}</option>)}</select></div>
          <div className="field"><label htmlFor="ad-d">Details</label><input id="ad-d" value={f.payment_details} onChange={(e) => setF({ ...f, payment_details: e.target.value })} /></div>
          <div className="form-actions"><button type="submit" className="btn primary"><i className="fas fa-plus" /> Record advance</button></div>
        </form>
      </section>
      <section className="panel">
        <div className="tbl-wrap"><table className="tbl">
          <thead><tr><th>#</th><th>Date</th><th>Client</th><th className="num">Amount</th><th>Method</th><th>Details</th><th /></tr></thead>
          <tbody>{d?.rows.map((r) => <tr key={r.payment_id}><td className="mono">{r.payment_id}</td><td>{String(r.payment_date).slice(0, 10)}</td>
            <td style={{ fontWeight: 600, color: "var(--ink)" }}>{r.client_name}</td><td className="num mono">{n2(r.payment_amount)}</td><td>{r.payment_method}</td>
            <td style={{ color: "var(--muted)" }}>{r.payment_details}</td><td><button type="button" className="btn sm" onClick={() => setRefund(r)}>Refund</button></td></tr>)}</tbody>
        </table>{d && d.rows.length === 0 && <div className="empty"><i className="fas fa-inbox" />No open advances.</div>}</div>
        {d && <Pager page={d.page} totalPages={d.pages} onPage={setPage} />}
      </section>
      {refund && <Modal title="Refund this advance?" onClose={() => setRefund(null)} actions={<><button type="button" className="btn" onClick={() => setRefund(null)}>Cancel</button><button type="button" className="btn danger" onClick={doRefund}>Refund</button></>}>
        TZS {n2(refund.payment_amount)} will be paid back to {refund.client_name} from cash. This can't be undone.</Modal>}
    </main>
  );
}
